module.exports = __webpack_public_path__ + "img/space-ship-2.05048bd4.svg";